<template>
  <div :class="{ 'dashboard-box-holder': loading }">
    <ag-loading v-if="loading" />
    <div class="p-2" style="min-height: 305px;" v-if="!loading && licenseData">
      <table class="table-responsive table licences-table">
        <thead>
          <th >{{ t("Licence Status") }}</th>
          <th class="text-center pl-0 pr-0">{{ t("Number of Companies") }}</th>
        </thead>
        <tbody>
          <tr>
            <td class="l-name">
              {{ t("Activated") }}
            </td>
            <td class="l-name l-count-big text-center">
              {{ licenseData.ActiveLicenseCount ? licenseData.ActiveLicenseCount : '' }}
            </td>
          </tr>
          <tr>
            <td class="l-name">
              {{ t("Not Activated") }}
            </td>
            <td class="l-name l-count-big text-center">
              {{ licenseData.InActiveLicenseCount ? licenseData.InActiveLicenseCount : '' }}
            </td>
          </tr>
          <tr>
            <td class="l-name">
              {{ t("Expired") }}
            </td>
            <td class="l-name l-count-big text-center">
              {{ licenseData.ExpiredLicenseCount ? licenseData.ExpiredLicenseCount : '' }}
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="text-center pt-3 pb-3 border-top bottom-link"
      >
        <router-link to="/administration/manage-license" class="ag-link">{{
          t("viewAll")
        }}</router-link>
      </div>
    </div>

    <div v-if="!loading && !licenseData" class="no-data-center">No Data</div>
  </div>
</template>

<script>
import api from "@/store/axiosAgsc";
import AgLoading from "@/components/ag-loading/index.vue";
import { mapState } from "vuex";
import { useI18n } from "vue-i18n";

export default {
  name: "Licences",
  data() {
    return {
      loading: false,
      licenseData: null,
    };
  },
  setup() {
    const { t, locale } = useI18n();
    return {
      t,
    };
  },
  components: {
    AgLoading,
  },
  computed: {
    ...mapState({
      company: (state) => state.auth.company,
    }),
  },
  mounted() {
    this.loading = true;
    api.get("Dashboard/GetGlobalCompanyLicenseDetails").then((res) => {
      this.licenseData = res && res.data ? res.data.entityData : null;
      this.loading = false;

    });
  },
};
</script>

<style scoped>
.link-blue {
  color: #4c8dbb !important;
}

.dashboard-box-holder {
  height: calc(100% - 75px);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
